var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"content"},[(_vm.singleCard)?_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_vm._t("default")],2)],1)],1):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }